import { CheckboxInput, FormItem, MenuPresets } from '@framework/form';
import React from 'react';
import styled from 'styled-components';
import { RichTextAdvancedInput } from '../../../../../inputs';
import { useTreeReferencesContext } from '../../../../../tree/references';
import { ConditionGroupInput } from '../../../../expressions/repository/condition-group/input/ConditionGroupInput';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { CodeLabelInputForm } from '../../inputs/common/CodeLabelInputForm';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { ComputedWidget } from '../IComputedWidget';

const InputBorder = styled.div`
  border: 1px solid ${props => props.theme.colorBorder};
  border-radius: 6px;
  padding: 8px;
`;

export interface IComputedBooleanConfigComponentProps
  extends IWidgetComponentProps<ComputedWidget> {}

export function ComputedBooleanConfigComponent(
  props: IComputedBooleanConfigComponentProps,
) {
  const options = getWidgetProps(props);
  const { references } = useTreeReferencesContext();

  return (
    <div>
      {/* Form Codice + Etichetta */}
      <CodeLabelInputForm widgetOptions={options} />

      <FormItem name="text" label="Testo">
        <RichTextAdvancedInput
          name="text"
          rows={2}
          menus={MenuPresets.Minimal}
        />
      </FormItem>

      <FormItem name="expression" label="Espressione">
        <InputBorder>
          <ConditionGroupInput name={`expression`} references={references} />
        </InputBorder>
      </FormItem>

      <FormItem
        name="layout.hide"
        label={null}
        layout={{ removeLabelSpace: true }}
      >
        <CheckboxInput name="layout.hide" defaultChecked={false}>
          Nascondi elemento in compilazione
        </CheckboxInput>
      </FormItem>
    </div>
  );
}
